export default {
  banner:
    'Je aanvraag moet opnieuw worden gestart op ons vernieuwde platform.\nLet op. Je moet mogelijk opnieuw inloggen.\nHeb je vragen? Plan gerust een adviesgesprek.',
  title: 'Afronden op dit platform is niet meer mogelijk.',
  cta: 'Start opnieuw',
  schedule: 'Adviesgesprek'
};
